import { createFileRoute } from '@tanstack/react-router'
import { DesignSystemLibraryPage } from 'pages/designSystemLibrary/DesignSystemLibraryPage'

import { designSystemLibrarySearchSchema } from './-searchParams'

function RouteComponent() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <DesignSystemLibraryPage
      search={search}
      onSearchChange={(next) =>
        void navigate({
          search: (previous) => ({ ...previous, ...next }),
          replace: true,
        })
      }
    />
  )
}

export const Route = createFileRoute('/design-system-library/')({
  component: RouteComponent,
  validateSearch: designSystemLibrarySearchSchema,
  staticData: {
    title: 'Design System Library',
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
      hideSiteSelector: true,
      showSearchBar: false,
    },
  },
})
